import React from 'react';
import { UserSummary } from './UserSummary';
import { bestDisplayNameforUser, hrefForUserCard } from '@fullstory/util/utils';
import { useLocation } from 'react-router-dom';
import { Box, Flex, InlineLink } from '@fullstory/components';
import { Avatar } from '@fullstory/overlays-ui';
import css from './userInfo.module.scss';
import { classNames } from '@fullstory/util/fmt';

interface UserInfoProps {
  indivId: string;
  displayName: string;
  created: Date;
  email?: string;
  gravatarURL?: string;
  onClick: () => void;
}

const UserInfo: React.FC<UserInfoProps> = ({
  created,
  displayName,
  email,
  indivId,
  gravatarURL,
  onClick,
}) => {
  const location = useLocation();
  const linkText = bestDisplayNameforUser(displayName, email ?? '');
  return (
    <Flex
      data-component="UserInfo"
      className={classNames('userInfo', css.userInfo)}
      alignItems="center"
      justifyContent="flex-start"
    >
      <Box marginRight={8}>
        <Avatar
          indivId={indivId}
          email={email}
          displayName={displayName}
          gravatarURL={gravatarURL}
          onClick={onClick}
        />
      </Box>
      <Box overflow="hidden" paddingRight={8} className="fs-exclude">
        <InlineLink
          className={classNames('name', css.nameAndSummary)}
          to={hrefForUserCard(location.pathname, indivId, location.search)}
          onClick={onClick}
        >
          {linkText}
        </InlineLink>
        <UserSummary created={created} email={email} />
      </Box>
    </Flex>
  );
};

export default UserInfo;
